import moment from 'moment';

export function calculatePostAdded(added_at: string) {
    let now = moment();
    let postDate = moment(added_at);
    let today = now.clone().startOf('day');
    let yesterday = today.clone().subtract(1, 'days');
    let diffInDays = now.diff(postDate, 'days', true);
    let diffInHours = now.diff(postDate, 'hours', true);
    let diffInMinutes = now.diff(postDate, 'minutes', true);

    if (diffInDays > 30) {
        return `${Math.round(diffInDays / 30)} month${Math.round(diffInDays / 30) > 1 ? 's' : ''} ago`;
    } else if (diffInDays > 7) {
        return `${Math.round(diffInDays / 7)} week${Math.round(diffInDays / 7) > 1 ? 's' : ''} ago`;
    } else if (postDate.startOf('day').isSame(yesterday)) {
        return 'Yesterday';
    } else if (diffInDays > 1) {
        return `${Math.round(diffInDays)} day${Math.round(diffInDays) > 1 ? 's' : ''} ago`;
    } else if (diffInHours > 1) {
        return `${Math.round(diffInHours)} hour${Math.round(diffInHours) > 1 ? 's' : ''} ago`;
    } else if (diffInMinutes > 3) {
        return `${Math.round(diffInMinutes)} minutes ago`;
    } else {
        return 'Just Now';
    }
}
